import { useEffect, useState } from "react";
import Api from "../openapi";
import { DriverBriefResponse } from "../openapi/client";

export default function useDrivers() {
  const [driverList, setDriverList] = useState<DriverBriefResponse[]>([]);
  useEffect(() => {
    const getDrivers = async () => {
      try {
        const res = await Api.Driver.listBriefDrivers();
        setDriverList(res.data);
      } catch (error) {}
    };
    getDrivers();
  }, []);
  return driverList;
}
